import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentErroServidor from './ContentErroServidor';

const ErroServidor = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentErroServidor />
      <Bottom />
    </div>
  );
};

export default ErroServidor;
